import EntitySync from "./EntitySync";
import StandKitsApi from "../../api/references/standkits";

/**
 * Offline-копия комплектаций стендов (ТЗ 241): плоские строки с полями действующей версии.
 */
class StandKitsSync extends EntitySync {
    constructor(props) {
        super(props, 'stand_kits', ['id', 'stand_id', 'title', 'serial_number', 'version_id', 'date_from', 'collection_ids', 'images', 'deleted'])
    }

    async fetchData(params) {
        const data_ = await StandKitsApi.getList({
            search: '',
            page: 1,
            epp: 4000,
            ...params
        })

        const data = data_.data

        if (data.results) {
            return data.results
        }
    }

    async getList(params) {
        try {
            const {search = '', epp, page} = params
            const ids = params.ids ? params.ids.split(',') : []
            const stand_id = params.stand_id ?? null
            const show_deleted = params.show_deleted ?? true

            const checkSearch = el => {
                let check = true

                if (ids.length > 0) {
                    if (ids.indexOf(el.id.toString()) == -1) check = false
                }
                if (stand_id && check) {
                    if (String(el.stand_id) != String(stand_id)) check = false
                }
                if (search.trim().length > 0 && check) {
                    if (!el.title.toLowerCase().includes(search.trim().toLowerCase())) check = false
                }
                if (!show_deleted && check) {
                    if (el.deleted == 1) check = false
                }
                return check
            }

            const total = await this.db[this.entityName]
                .filter(el => checkSearch(el))
                .count()

            const results = await this.db[this.entityName].orderBy('title')
                .filter(el => checkSearch(el))
                .offset((page - 1) * epp)
                .limit(epp)
                .toArray()

            return {
                data: {
                    results,
                    total,
                    iTotalPages: Math.ceil(total / epp),
                    iTotalRecords: total,
                    iTotalDisplayRecords: results.length
                }
            }
        } catch (error) {
            console.error('Ошибка при получении списка комплектаций:', error)
            return {
                data: {
                    results: [],
                    total: 0,
                    iTotalPages: 0
                }
            }
        }
    }
}

export default StandKitsSync
